import { ActionType, ResourceType } from "./permission-types";

const RESOURCE_TO_ENTITY_TYPE: Partial<Record<ResourceType, string>> = {
  climateAction: "CLIMATE_ACTION",
  project: "PROJECT",
  task: "TASK",
  inventory: "INVENTORY",
  municipalPropertyRegister: "MUNICIPAL_PROPERTY_REGISTER",
  scenarioModel: "SCENARIO_MODEL",
  dashboard: "DASHBOARD",
  indicator: "INDICATOR",
};

const RIGHT_HIERARCHY: Record<string, number> = {
  OWNER: 4,
  EDITOR: 3,
  VIEWER: 2,
  NONE: 1,
};

const ACTION_TO_MIN_RIGHT: Record<ActionType, string> = {
  view: "VIEWER",
  view_public: "VIEWER",
  write: "EDITOR",
  manage: "OWNER",
  delete: "OWNER",
};

export const getEntityTypeForResource = (resource: ResourceType): string | null => {
  return RESOURCE_TO_ENTITY_TYPE[resource] ?? null;
};

export const hasRequiredRight = (effectiveRight: string | null, action: ActionType): boolean => {
  if (!effectiveRight) {
    return false;
  }

  const minRight = ACTION_TO_MIN_RIGHT[action];
  if (!minRight) {
    return false;
  }

  const userLevel = RIGHT_HIERARCHY[effectiveRight];
  if (userLevel === undefined) {
    return false;
  }

  return userLevel >= RIGHT_HIERARCHY[minRight];
};
